/**
 * Created by litao on 2018/10/8.
 */
export default (http) => {
    return {
        /**
         * 查询活动列表
         */
        queryActivityList(data) {
            return http.json({
                url: 'sys/activity/query',
                data
            })
        },

        /**
         * 查询活动详情
         */
        getActivityInfo(data) {
            return http({
                url: `sys/activity/get?id=${data.id}`,
                method: 'post'
            });
        },


        /**
         * 保存活动
         */
        saveActivityInfo(data) {
            return http.json({
                url: 'sys/activity/save',
                data
            })
        },

        /**
         * @param data
         * @return {*}
         */
        removeActivity(data) {
            return http.json({
                url: '/sys/activity/delete',
                data
            })
        },


        switchRecommendState (data){
            return http.json({
                url: `/sys/activity/switchRecommendState`,
                data
            })
        },

        switchRecommendStateInformation (data){
            return http.json({
                url: `/sys/article/switchRecommendState`,
                data
            })
        },


        /**
         * 发布
         * @param data
         * @return {*}
         */
        activityPublish(data) {
            return http({
                url: `/sys/activity/publish?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 取消发布
         * @param data
         * @return {*}
         */
        activityUnPublish(data) {
            return http({
                url: `/sys/activity/unPublish?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryInformationList(data) {
            return http.json({
                url: `sys/article/queryCMS?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },


        /**
         * 查询活动详情
         */
        getInformationInfo(data) {
            return http({
                url: `sys/article/get?id=${data.id}`,
                method: 'post'
            });
        },


        /**
         * 保存活动
         */
        saveInformationInfo(data) {
            return http.json({
                url: 'sys/article/save',
                data
            })
        },


        /**
         * @param data
         * @return {*}
         */
        removeInformation(data) {
            return http.json({
                url: '/sys/article/delete',
                data
            })
        },

        /**
         * 发布
         * @param data
         * @return {*}
         */
        articlePublish(data) {
            return http({
                url: `/sys/article/publish?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 取消发布
         * @param data
         * @return {*}
         */
        articleUnPublish(data) {
            return http({
                url: `/sys/article/unPublish?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryBannerList(data) {
            return http.json({
                url: 'sys/banner/query',
                data
            })
        }
        ,


        /**
         * 查询活动详情
         */
        getBannerInfo(data) {
            return http({
                url: `sys/banner/get?id=${data.id}`,
                method: 'post'
            });
        }
        ,


        /**
         * 保存活动
         */
        saveBannerInfo(data) {
            return http.json({
                url: 'sys/banner/save',
                data
            })
        }
        ,

        /**
         * @param data
         * @return {*}
         */
        removeBanner(data) {
            return http.json({
                url: '/sys/banner/delete',
                data
            })
        }
        ,

        /**
         * 发布
         * @param data
         * @return {*}
         */
        bannerPublish(data) {
            return http({
                url: `/sys/banner/publish?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 取消发布
         * @param data
         * @return {*}
         */
        bannerUnPublish(data) {
            return http({
                url: `/sys/banner/unPublish?id=${data.id}`,
                method: 'post'
            })
        },


        queryOrgTree(data) {
            return http.json({
                url: 'sys/org/query',
                data
            })
        }
        ,

        queryPosition(data) {
            return http.json({
                url: 'sys/org/queryPosition',
                data
            })
        }
        ,
        queryOrgTreeList(data) {
            return http.json({
                url: '/sys/org/query',
                data: {"type": "org"}
            });
        }
        ,
        queryTenantTreeListNotCheck(data) {
            return http.json({
                url: '/sys/org/query',
                data: {"type": "tenant"}
            });
        }
        ,
        queryTenantTreeList(data) {
            return http.json({
                url: '/sys/org/query',
                data: {"type": "tenant", "checkTenant": "1"}
            });
        }
        ,
        queryOrgOnly(data) {
            return http.json({
                url: 'sys/org/queryOrg',
                data
            })
        }
        ,

        toggleState(data) {
            return http({
                url: `/sys/org/toggleState?id=${data.id}&state=${data.state}`,
                method: 'post'
            })
        }
        ,

        /**
         * 获取字典详情
         * @param data
         * @return {*}
         */
        getDictInfo(data) {
            return http({
                url: `sys/org/get?id=${data.id}`,
                method: 'post'
            })
        }
        ,

        /**
         * 保存字典信息
         * @param data
         * @return {*}
         */
        saveDictInfo(data) {
            return http.json({
                url: 'sys/org/save',
                data
            })
        }
        ,

        /**
         * 删除字典
         * @param data
         * @return {*}
         */
        removeDict(data) {
            return http.json({
                url: 'sys/org/delete',
                data
            })
        },


        /**
         * 查询活动详情
         */
        servieInfo(data) {
            return http({
                url: `sys/service/get?id=${data.id}`,
                method: 'post'
            });
        },

        /**
         * 保存活动
         */
        savServieInfo(data) {
            return http.json({
                url: 'sys/service/save',
                data
            })
        },




        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryShopList(data) {
            return http.json({
                url: 'sys/shop/query',
                data
            })
        }
        ,


        /**
         * 查询活动详情
         */
        getShopInfo(data) {
            return http({
                url: `sys/shop/get?id=${data.id}`,
                method: 'post'
            });
        }
        ,


        /**
         * 保存活动
         */
        saveShopInfo(data) {
            return http.json({
                url: 'sys/shop/save',
                data
            })
        }
        ,

        /**
         * @param data
         * @return {*}
         */
        removeShop(data) {
            return http.json({
                url: '/sys/shop/delete',
                data
            })
        }
        ,

        /**
         * 发布
         * @param data
         * @return {*}
         */
        shopPublish(data) {
            return http({
                url: `/sys/shop/publish?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 取消发布
         * @param data
         * @return {*}
         */
        shopUnPublish(data) {
            return http({
                url: `/sys/shop/unPublish?id=${data.id}`,
                method: 'post'
            })
        },




    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/wx.js